import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import ExcludedIps from './ExcludedIps';

export type TagsInputValue = any[]

const mapStateToProps = (state: any, { t }: { t: any }) => {
  const excludedIps: TagsInputValue = state.trackerSettings.app.settings
    .attributes.excluded_ips || [];
  const globalExcludedIps: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.excluded_ips || []
  )
    .map(
      (element: any) => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalExcludedIps,
    ...excludedIps,
  ];

  return {
    globalAndAppTrackerSettings,
    appTrackerSettings: excludedIps,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(ExcludedIps));
